import React from 'react';

import Attributes from '@components/routes/AdminPanel/AssetProfile/Attributes';
import IncomingRequests from '@components/routes/AdminPanel/AssetProfile/IncomingRequests';
import OutgoingRequests from '@components/routes/AdminPanel/AssetProfile/OutgoingRequests';
import Summary from '@components/routes/AdminPanel/AssetProfile/Summary';
import TelecomSites from '@components/routes/AdminPanel/AssetProfile/TelecomSites';

import { TAssetProfile } from '@interfaces/assets/asset';

import { tabsNames } from '@components/routes/AdminPanel/AssetProfile/constants';

interface IGetCurrentTab {
	currentTab: string;
	profile?: TAssetProfile;
	isEditAccess: boolean;
	toggleAssetModal: () => void;
	handleUpdateAssetAccessAvailability: () => void;
	handleUpdateAssetSiteAvailability: () => void;
	handleUpdateAssetSpecialImplementationIssues: () => void;
	handleUpdateBackhaulAccessibility: () => void;
	handleUpdatePowerSupplyAvailability: () => void;
	isManageAsset: boolean;
}

export const getCurrentTab = ({
	currentTab,
	profile,
	isEditAccess,
	toggleAssetModal,
	handleUpdateAssetAccessAvailability,
	handleUpdateAssetSiteAvailability,
	handleUpdateAssetSpecialImplementationIssues,
	handleUpdateBackhaulAccessibility,
	handleUpdatePowerSupplyAvailability,
	isManageAsset,
}: IGetCurrentTab) => {
	switch (currentTab) {
		case tabsNames.summary:
			return (
				<Summary
					isEditAccess={isEditAccess}
					profile={profile}
					toggleAssetModal={toggleAssetModal}
				/>
			);

		case tabsNames.attributes:
			return (
				<Attributes
					handleUpdateAssetAccessAvailability={handleUpdateAssetAccessAvailability}
					handleUpdateAssetSiteAvailability={handleUpdateAssetSiteAvailability}
					handleUpdateAssetSpecialImplementationIssues={handleUpdateAssetSpecialImplementationIssues}
					handleUpdateBackhaulAccessibility={handleUpdateBackhaulAccessibility}
					handleUpdatePowerSupplyAvailability={handleUpdatePowerSupplyAvailability}
					isEditAccess={isEditAccess}
					profile={profile}
				/>
			);

		case tabsNames.outgoingRequests:
			return <OutgoingRequests assetDbId={profile?.id} />;

		case tabsNames.incomingRequests:
			return <IncomingRequests assetDbId={profile?.id} />;

		case tabsNames.telecomSites:
			return (
				<TelecomSites
					assetDbId={profile?.id}
					isManageAsset={isManageAsset}
					rentInfo={profile?.rentInfo}
				/>
			);

		default:
			return (
				<Summary
					isEditAccess={isEditAccess}
					profile={profile}
					toggleAssetModal={toggleAssetModal}
				/>
			);
	}
};
